














import mixins from 'vue-typed-mixins';
import UserAgreementForm from '@/components/user/UserAgreementForm.vue';
import UserAgreementUtils, { UserAgreement } from '@/utils/UserAgreementUtils';
export default mixins().extend({
  components: {
    UserAgreementForm,
  },

  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },

  data(): {
    item?: Partial<UserAgreement>;
  } {
    return {
      item: undefined,
    };
  },

  async mounted() {
    try {
      if (this.id) {
        this.item = await UserAgreementUtils.api.get(this.id);
      }
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    async save() {
      if (this.item) {
        try {
          this.$alert.hide('save');
          this.item = await UserAgreementUtils.api.update(this.item);
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.default', {
              values: [this.item?.name],
            }),
          });
        } catch (error) {
          this.$alert.show('save', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      }
    },
  },
});
